import { gql, useQuery } from "@apollo/client";
import Markdown from "react-markdown";
import styles from "./Announcement.module.scss";

interface AnnouncementProps {
  id: string;
}

export default function Announcement({ id }: AnnouncementProps) {
  const { error, data } = useQuery(GET_PRODUCT_ANNOUNCEMENT, {
    fetchPolicy: "cache-and-network",
    variables: {
      productId: id,
    },
  });

  if (error || !data || !data.product.announcement) {
    return <></>;
  }
  const { product } = data;
  const { announcement } = product;
  const { active, content } = announcement;
  return (
    <>
      {active && (
        <section className={styles.Announcement}>
          <div className="AppLayout">
            <Markdown components={{ a: LinkRenderer }}>{content}</Markdown>
          </div>
        </section>
      )}
    </>
  );
}

const GET_PRODUCT_ANNOUNCEMENT = gql`
  query ($productId: ID!) {
    product(id: $productId) {
      announcement {
        content
        active
      }
    }
  }
`;

function LinkRenderer(props) {
  return (
    <a href={props.href} target="_blank" rel="noreferrer">
      {props.children}
    </a>
  );
}
